import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { tableHeaders, columnNames } from "./utils";
// components
import CardTable from "components/Cards/CardTable.js";
import LevyTopTable from "./LevyTopTable";
import { fetchLevies } from "services/fetchData";
import axios from "axios";
import { baseUrl } from "utils/api";

export default function Levy() {
  const [data, setData] = useState();
  const [status, setStatus] = useState("loading");
  const [searchBy, setSearchBy] = useState("Code");
  const [value, setValue] = useState("");
  const token = localStorage.getItem("token");

  const getLevies = async () => {
    var config = {
      method: "get",
      url: `${baseUrl}levies`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axios(config)
      .then(function (response) {
        const { data } = response.data;
        setData(response.data);
        setStatus("finished");
      })
      .catch(function (error) {
        return error;
      });
  };

  const getSearchedLevy = async () => {
    var config = {
      method: "get",
      url: `${baseUrl}levies/${value}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axios(config)
      .then(function (response) {
        const { data: levies } = response;
        if (response.status >= 200 && response.status < 300) {
          setData(levies);
          setStatus("finished");
        } else {
          setData([]);
          setStatus(response.message);
        }
      })
      .catch(function (error) {
        setData([]);
        setStatus("Input unavailable");
        return error;
      });
  };

  useEffect(() => {
    if (value) {
      setData([]);
      setStatus("loading");
      getSearchedLevy();
    } else {
      getLevies();
    }
  }, [value, searchBy]);
  return (
    <>
      <div className="flex flex-wrap pt-24 mx-12 w-full">
        <div className="mb-12" style={{ margin: "auto", width: "90%" }}>
          <LevyTopTable setValue={setValue} setSearchBy={setSearchBy} />
          <CardTable
            color="dark"
            name="LEVIES"
            tableHeaderArr={tableHeaders}
            columnNamesArr={columnNames}
            tableData={data}
            status={status}
          />
        </div>
      </div>
    </>
  );
}
